import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dropdown,
  Modal,
  OverlayTrigger,
  Tooltip,
  Button
} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import * as Fi from 'react-icons/fi';
import _ from 'underscore';

import { Order } from 'services/action';

import { Skeletons } from 'ui/components/skeleton';
import UpdateItems from '../table/update.items';
import { FormUpdatePricing } from '../form/price';
import { FormReason } from '../form/reason';
import { isNotClient } from 'utilities/common';

const initialState = {
  privilege: null,
  showPrice: false,
  showVoid: false,
  showRestore: false,
};

export const Action = ({ data, onSubmit }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);
  const Session = useSelector((state) => state.Auth?.session);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Order.Show']
  );

  const [{ privilege, showVoid, showPrice, showRestore }, setState] =
    React.useState(initialState);

  const $getPrivilege = async () => {
    const payload = {};

    const delivery = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.delivery',
    });

    const pricing = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.pricing',
    });

    if (pricing) {
      payload.pricing = pricing;
    }

    if (delivery) {
      payload.delivery = delivery;
    }

    setState((prevState) => ({ ...prevState, privilege: payload }));
  };

  const $handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      showVoid: false,
      showPrice: false,
      showRestore: false,
    }));
  };

  const $handleRestore = async () => {
    const req = await Dispatch(Order.$restore(data?.id));
    if (req?.message === 'success') {
      onSubmit();
      $handleClose();
    }
  };

  React.useEffect(() => {
    $getPrivilege();
  }, [Session]);

  const dummy = Array.from({ length: 6 }, (v, i) => i);

  const SettingAction = () => {
    return privilege?.delivery?.action === 'manage' || !Session?.privileges ? (
      <Dropdown className="d-inline p-0 m-0 split-carret" as="div" align="end">
        <Dropdown.Toggle
          id="dropdown-autoclose-true"
          className="d-flex p-0  justify-content-between "
        >
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-top`}>Pengaturan</Tooltip>}
          >
            <div
              className=" border-end border-light"
              style={{ padding: '4.4px 8px' }}
            >
              <Fi.FiSettings size="17" className=" border-end" />
            </div>
          </OverlayTrigger>
        </Dropdown.Toggle>

        <Dropdown.Menu className="py-0 rounded-2">
          <UpdateItems data={data} onClose={onSubmit} />

          {(!Session?.privileges || privilege?.pricing) && (
            <div
              className="dropdown-item d-flex align-items-center cursor-pointer  "
              onClick={() =>
                setState((prevState) => ({
                  ...prevState,
                  showPrice: true,
                }))
              }
            >
              <Fi.FiCreditCard size={15} color="#202020" className="me-2" />
              Perbaharui Harga
            </div>
          )}
          {(data?.document_status === 'new' ||
            data?.document_status === 'console' || data?.document_status === 'disputed') && (
            <div
              className="dropdown-item d-flex align-items-center text-danger  cursor-pointer  "
              onClick={() =>
                setState((prevState) => ({
                  ...prevState,
                  showVoid: true,
                }))
              }
            >
              <Fi.FiX size={15} color="#FF1818" className="me-2" />
              Batalkan Shipment
            </div>
          )}
        </Dropdown.Menu>
      </Dropdown>
    ) : null;
  };

  const PrintAction = () => {
    return (
      <Dropdown className="d-inline p-0 m-0 split-carret" as="div" align="end">
        <Dropdown.Toggle
          id="dropdown-autoclose-true"
          className="d-flex p-0  justify-content-between "
        >
          <OverlayTrigger
            placement="bottom"
            overlay={<Tooltip id={`tooltip-top`}>Print</Tooltip>}
          >
            <div
              className="border-end border-light"
              style={{ padding: '4.4px 8px' }}
            >
              <Fi.FiPrinter size="17" className=" border-end" />
            </div>
          </OverlayTrigger>
        </Dropdown.Toggle>

        <Dropdown.Menu className="py-0 rounded-2">
          <Link
            className="dropdown-item d-flex align-items-center border-bottom"
            role="button"
            to={`/print/shipment/${data?.id}`}
            target="_blank"
          >
            <Fi.FiPrinter size={15} color="#202020" className="me-2" />
            Print Surat Muat
          </Link>
          <Link
            className="dropdown-item d-flex align-items-center"
            role="button"
            to={`/print/resi/${data?.id}`}
            target="_blank"
          >
            <Fi.FiPrinter size={15} color="#202020" className="me-2" />
            Print Resi
          </Link>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  if (isNotClient(Session?.client?.id, data?.order?.client?.id)) {
    return null;
  }

  return (
    <div className="d-flex align-items-center gap-1 px-3 px-md-0 pb-2 pb-md-0">
      {StateLoading ? (
        dummy?.map((d, i) => <Skeletons key={i} height="35px" width="35px" />)
      ) : (
        <>
          {data?.document_status !== 'voided' && (
            <>
              {/* <StandardAction /> */}
              <PrintAction />
              {data?.shipment?.type === 'ltl' && <SettingAction />}
            </>
          )}

          {((data?.document_status === 'voided' || data?.document_status === 'disputed' || data?.document_status === 'delivered' || data?.document_status === 'returned') && (privilege?.delivery?.action === 'restore' || Session?.user?.id === '16a5d350-12a1-407b-b55f-0252b7df8d0a'))  && (
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id={`tooltip-top`}>Balikan Status</Tooltip>
              }
            >
              <button
                className='btn btn-danger px-2'
                onClick={() =>
                  setState((prevState) => ({
                    ...prevState,
                    showRestore: true,
                  }))
                }
              >
                <Fi.FiRotateCcw size={17} />
              </button>
            </OverlayTrigger>
          )}
        </>
      )}

      {/* modal delete */}
      <Modal
        show={showVoid}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dibatalkan tidak bisa diproses ulang
          </p>

          <FormReason
            data={data}
            onSubmit={() => {
              onSubmit();
              $handleClose();
            }}
          />
        </Modal.Body>
      </Modal>

      {/* modal restore */}
      <Modal
        show={showRestore}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data status akan dikembalikan ke status sebelumnya tidak bisa diproses ulang!
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button variant="white" className="w-100" onClick={$handleClose}>
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleRestore}
                disabled={StateForm?.loading}
              >
                Simpan
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal update harga */}
      <Modal
        show={showPrice}
        onHide={$handleClose}
        backdrop="static"
        centered
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-primary" />
          <h3 className="text-center mb-3">Update harga</h3>
          <FormUpdatePricing
            data={data}
            onSubmit={() => {
              onSubmit();
              $handleClose();
            }}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};
